import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Home, History, User } from "lucide-react";

const navItems = [
  { path: "/app", label: "Home", icon: Home },
  { path: "/app/submit-reimbursement", label: "Activity", icon: History },
  { path: "/app/submit-rebate", label: "Profile", icon: User },
] as const;

export default function SupervisorLayout() {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === "/app") {
      return (
        location.pathname === "/app" ||
        location.pathname.startsWith("/app/stock") ||
        location.pathname.startsWith("/app/sales")
      );
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex flex-col h-screen max-w-md mx-auto bg-white shadow-xl relative">
      <main className="flex-1 overflow-y-auto bg-white pb-16">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 mx-auto w-full max-w-md bg-white border-t border-gray-200 flex justify-around items-center h-[60px] z-50">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                active ? "text-primary" : "text-gray-500 hover:text-primary"
              }`}
            >
              <Icon size={22} className="mb-1" />
              <span className="text-[12px] leading-3 font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}

